(function(){
  if (window.__mpnModal) return; window.__mpnModal = true;
  var MPN_LANG = (document.documentElement.lang || 'fr').slice(0, 2);
  var MPN_T = {
    fr: { img: 'Image', prev: 'Image précédente', next: 'Image suivante' },
    en: { img: 'Image', prev: 'Previous image', next: 'Next image' },
    de: { img: 'Bild', prev: 'Vorheriges Bild', next: 'Nächstes Bild' }
  }[MPN_LANG] || { img: 'Image', prev: 'Image précédente', next: 'Image suivante' };
  var mq = { matches: true };
  var MAX = 4;
  function items(content){ return [].slice.call(content.children); }
  function thumbSrc(el){
    var img = el.tagName === 'IMG' ? el : el.querySelector('img');
    if (!img) return '';
    var s = img.getAttribute('src') || img.currentSrc || '';
    if (!s) return '';
    return /[?&]width=\d+/.test(s) ? s.replace(/([?&])width=\d+/, '$1width=180') : s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=180';
  }
  function idxOf(content){ return Math.round(content.scrollLeft / (content.clientWidth || 1)); }
  function goTo(content, k, smooth){ content.scrollTo({ left: k * content.clientWidth, behavior: smooth ? 'smooth' : 'auto' }); }
  /* Position absolue du bandeau : 1re image => bandeau tout au debut ; ensuite la miniature active reste centree,
     sans jamais depasser le debut ou la fin du bandeau. */
  function centerThumb(thumbs, a, smooth){
    if (!a) return;
    var max = Math.max(0, thumbs.scrollWidth - thumbs.clientWidth);
    var target = a.offsetLeft - (thumbs.clientWidth - a.offsetWidth) / 2;
    target = Math.max(0, Math.min(max, target));
    thumbs.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'auto' });
  }

  /* ---------- Zoom (pincement / double-tap) sur l'image seule ---------- */
  function zoomState(modal){ return modal.__mpnZ || (modal.__mpnZ = { el: null, s: 1, tx: 0, ty: 0 }); }
  function apply(z, animate){
    if (!z.el) return;
    z.el.style.transition = animate ? 'transform .22s ease' : 'none';
    z.el.style.transform = z.s > 1 ? 'translate(' + z.tx + 'px,' + z.ty + 'px) scale(' + z.s + ')' : '';
  }
  function clampT(z){
    if (!z.el) return;
    var w = z.el.clientWidth, h = z.el.clientHeight;
    var mx = (z.s - 1) * w / 2, my = (z.s - 1) * h / 2;
    z.tx = Math.max(-mx, Math.min(mx, z.tx));
    z.ty = Math.max(-my, Math.min(my, z.ty));
  }
  function resetZoom(modal, animate){
    var z = zoomState(modal);
    if (z.el) { z.s = 1; z.tx = 0; z.ty = 0; apply(z, animate); }
    z.el = null;
    if (modal.__mpnZl) { modal.__mpnZl.classList.remove('is-on'); if (modal.__mpnZl.__raf) { cancelAnimationFrame(modal.__mpnZl.__raf); modal.__mpnZl.__raf = 0; } }
    var content = modal.querySelector('.product-media-modal__content');
    if (content) content.classList.remove('is-zoomed');
  }
  function currentImg(content){
    var el = items(content)[idxOf(content)];
    return el && el.tagName === 'IMG' ? el : null;
  }
  function centerOf(el){ var r = el.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; }
  function dist(a, b){ return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
  function mid(a, b){ return { x: (a.clientX + b.clientX) / 2, y: (a.clientY + b.clientY) / 2 }; }

  function mark(modal, smooth){
    var content = modal.querySelector('.product-media-modal__content');
    var thumbs = modal.querySelector('.mpn-modal-thumbs');
    var count = modal.querySelector('.mpn-modal-count');
    if (!content || !thumbs) return;
    var n = thumbs.children.length; if (!n) return;
    var i = Math.max(0, Math.min(n - 1, idxOf(content)));
    if (modal.__mpnIdx === i && !smooth) return;
    modal.__mpnIdx = i;
    [].forEach.call(thumbs.children, function(b, k){ b.classList.toggle('is-active', k === i); });
    if (count) count.textContent = (i + 1) + ' / ' + n;
    centerThumb(thumbs, thumbs.children[i], smooth !== false);
    media(content, i);
  }
  /* Videos dans la visionneuse : la video affichee se lance, les autres se mettent en pause */
  function media(content, i){
    items(content).forEach(function(el, k){
      if (k === i) return;
      el.querySelectorAll && el.querySelectorAll('video').forEach(function(v){ if (v.pause) v.pause(); });
    });
    var cur = items(content)[i];
    if (!cur || cur.nodeName !== 'DEFERRED-MEDIA') return;
    if (!cur.getAttribute('loaded') && cur.loadContent) cur.loadContent(false);
    else cur.querySelectorAll('video').forEach(function(v){ var p = v.play && v.play(); if (p && p.catch) p.catch(function(){}); });
    var touch = window.matchMedia('(hover: none), (max-width: 749px)').matches;
    cur.querySelectorAll('video').forEach(function(v){
      v.setAttribute('playsinline', ''); v.playsInline = true;
      v.__mpnCtl = true; v.controls = false; v.removeAttribute('controls');
      if (v.paused) { if (touch) { v.muted = true; v.setAttribute('muted', ''); } var pp = v.play && v.play(); if (pp && pp.catch) pp.catch(function(){ v.muted = true; v.setAttribute('muted', ''); var p2 = v.play(); if (p2 && p2.catch) p2.catch(function(){}); if (cur.__mpnSync) cur.__mpnSync(); }); }
      mobCtl(cur, v);
    });
  }
  /* Mobile / tactile : pas de barre de lecture native (elle restait affichee et ses boutons ne repondaient pas).
     Toucher la video = pause / lecture ; bouton son en bas a droite. */
  var SND_OFF = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M17 9l4 6M21 9l-4 6"/></svg>';
  var SND_ON = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12"/></svg>';
  var SND_T = { fr: ['Activer le son', 'Couper le son'], en: ['Sound on', 'Sound off'], de: ['Ton an', 'Ton aus'] }[MPN_LANG] || ['Activer le son', 'Couper le son'];
  function fmt(t){ t = Math.max(0, Math.floor(t || 0)); var m = Math.floor(t / 60), x = t % 60; return m + ':' + (x < 10 ? '0' : '') + x; }
  var GLYPH_PLAY = '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5z" fill="currentColor"/></svg>';
  var GLYPH_PAUSE = '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z" fill="currentColor"/></svg>';
  /* Mobile / tactile : commandes maison (la barre native d'iPhone restait affichee et ne repondait pas).
     Toucher la video = pause / lecture + affichage bref des commandes (icone 0,6 s, barre ~2,5 s).
     Barre : glisser le doigt pour avancer / reculer. Bouton son toujours visible en bas a droite. */
  function mobCtl(dm, v){
    var vid = function(){ return dm.querySelector('video') || v; };
    if (!dm.__mpnMob) {
      dm.__mpnMob = true;
      var ui = document.createElement('div'); ui.className = 'mpn-mv-ui';
      ui.innerHTML = '<span class="mpn-mv-ic" aria-hidden="true"></span>'
        + '<div class="mpn-mv-bar"><span class="mpn-mv-t mpn-mv-cur">0:00</span><div class="mpn-mv-track"><div class="mpn-mv-fill"></div><div class="mpn-mv-knob"></div></div><span class="mpn-mv-t mpn-mv-dur">0:00</span></div>'
        + '<button type="button" class="mpn-mv-snd"></button>';
      dm.appendChild(ui);
      var ic = ui.querySelector('.mpn-mv-ic'), bar = ui.querySelector('.mpn-mv-bar'), track = ui.querySelector('.mpn-mv-track');
      var fill = ui.querySelector('.mpn-mv-fill'), knob = ui.querySelector('.mpn-mv-knob');
      var cur = ui.querySelector('.mpn-mv-cur'), dur = ui.querySelector('.mpn-mv-dur'), snd = ui.querySelector('.mpn-mv-snd');
      var icT = 0, barT = 0, dragging = false;
      function showIcon(playing){
        ic.innerHTML = playing ? GLYPH_PLAY : GLYPH_PAUSE;
        ic.classList.remove('is-on'); void ic.offsetWidth; ic.classList.add('is-on');
        clearTimeout(icT); icT = setTimeout(function(){ ic.classList.remove('is-on'); }, 600);
      }
      function hideBar(){ if (dragging) return; bar.classList.remove('is-on'); dm.classList.remove('mpn-ui-on'); }
      function showBar(ms){
        bar.classList.add('is-on'); dm.classList.add('mpn-ui-on');
        clearTimeout(barT);
        barT = setTimeout(hideBar, ms || 2500);
      }
      function paint(r){ r = Math.max(0, Math.min(1, r)); fill.style.width = (r * 100) + '%'; knob.style.left = (r * 100) + '%'; }
      function upd(){
        var vv = vid(); if (!vv) return;
        var d = vv.duration || 0;
        dur.textContent = fmt(d);
        if (!dragging) { cur.textContent = fmt(vv.currentTime); paint(d ? vv.currentTime / d : 0); }
      }
      function seekAt(x){
        var vv = vid(); if (!vv || !vv.duration) return;
        var r = track.getBoundingClientRect();
        var k = Math.max(0, Math.min(1, (x - r.left) / (r.width || 1)));
        paint(k); vv.currentTime = k * vv.duration; cur.textContent = fmt(vv.currentTime);
      }
      /* Ordinateur : les commandes prennent la taille et la place exactes de l'image video (pas toute la largeur de l'ecran) */
      function place(){
        var vv = vid(); if (!vv) return;
        if (!window.matchMedia('(min-width: 750px) and (hover: hover)').matches) { ['inset', 'left', 'top', 'width', 'height'].forEach(function(p){ ui.style.removeProperty(p); }); return; }
        var dr = dm.getBoundingClientRect(), r = vv.getBoundingClientRect();
        var x = r.left - dr.left, y = r.top - dr.top, w = r.width, h = r.height, vw = vv.videoWidth, vh = vv.videoHeight;
        if (!(vw && vh && w && h)) return; /* dimensions pas encore connues : commandes invisibles, rien ne saute */
        var s = Math.min(w / vw, h / vh), cw = vw * s, ch = vh * s; x += (w - cw) / 2; y += (h - ch) / 2; w = cw; h = ch;
        ui.style.setProperty('inset', 'auto', 'important');
        ui.style.setProperty('left', x + 'px', 'important'); ui.style.setProperty('top', y + 'px', 'important');
        ui.style.setProperty('width', w + 'px', 'important'); ui.style.setProperty('height', h + 'px', 'important');
        ui.classList.add('is-placed');
      }
      dm.__mpnPlace = place;
      window.addEventListener('resize', place);
      dm.addEventListener('loadedmetadata', place, true);
      function sync(){ var vv = vid(); if (!vv) return; snd.innerHTML = vv.muted ? SND_OFF : SND_ON; snd.setAttribute('aria-label', vv.muted ? SND_T[0] : SND_T[1]); }
      dm.__mpnSync = sync;
      /* Glisser sur la barre (gere a la main : le curseur natif ne repond pas sur iPhone dans la visionneuse) */
      bar.addEventListener('touchstart', function(e){ e.preventDefault(); e.stopPropagation(); dragging = true; bar.classList.add('is-on'); clearTimeout(barT); seekAt(e.touches[0].clientX); }, { passive: false });
      bar.addEventListener('touchmove', function(e){ e.preventDefault(); e.stopPropagation(); if (dragging) seekAt(e.touches[0].clientX); }, { passive: false });
      bar.addEventListener('touchend', function(e){ e.stopPropagation(); dragging = false; showBar(2500); }, { passive: true });
      bar.addEventListener('mousedown', function(e){
        e.preventDefault(); e.stopPropagation(); dragging = true; seekAt(e.clientX);
        function mv(ev){ seekAt(ev.clientX); }
        function up(){ dragging = false; showBar(2500); document.removeEventListener('mousemove', mv); document.removeEventListener('mouseup', up); }
        document.addEventListener('mousemove', mv); document.addEventListener('mouseup', up);
      });
      ['click', 'pointerdown', 'pointerup'].forEach(function(t){ bar.addEventListener(t, function(e){ e.stopPropagation(); }); });
      snd.addEventListener('touchstart', function(e){ e.stopPropagation(); }, { passive: true });
      snd.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var vv = vid(); if (!vv) return;
        vv.muted = !vv.muted; if (!vv.muted) vv.removeAttribute('muted');
        if (vv.paused) { var p = vv.play(); if (p && p.catch) p.catch(function(){}); }
        sync();
      });
      dm.addEventListener('click', function(e){
        if (e.target.closest && e.target.closest('.mpn-mv-snd, .mpn-mv-bar')) return;
        var vv = vid(); if (!vv) return;
        e.preventDefault(); e.stopPropagation();
        if (vv.paused) { var p = vv.play(); if (p && p.catch) p.catch(function(){}); showIcon(true); }
        else { vv.pause(); showIcon(false); }
        showBar(2500);
      });
      /* Ordinateur : la barre apparait des que la souris bouge sur la video */
      dm.addEventListener('mousemove', function(e){ showBar(e.target.closest && e.target.closest('.mpn-mv-bar, .mpn-mv-snd') ? 4000 : 1200); });
      dm.addEventListener('mouseleave', function(){ clearTimeout(barT); hideBar(); });
      dm.addEventListener('timeupdate', upd, true);
      dm.addEventListener('loadedmetadata', upd, true);
      dm.addEventListener('durationchange', upd, true);
      dm.addEventListener('volumechange', sync, true);
      upd();
      if (!window.matchMedia('(min-width: 750px) and (hover: hover)').matches) showBar(2500);
    }
    if (dm.__mpnSync) dm.__mpnSync();
    if (dm.__mpnPlace) { dm.__mpnPlace(); requestAnimationFrame(dm.__mpnPlace); setTimeout(dm.__mpnPlace, 400); }
  }

  function build(modal){
    var content = modal.querySelector('.product-media-modal__content');
    var thumbs = modal.querySelector('.mpn-modal-thumbs');
    if (!content || !thumbs || modal.__mpnBuilt) return;
    modal.__mpnBuilt = true;
    /* Le theme ferme la visionneuse au moindre clic souris dedans : on ne la ferme plus que par la croix / Echap,
       pour pouvoir cliquer sur les fleches, les miniatures et la video. */
    var dlg = modal.querySelector('.product-media-modal__dialog');
    if (dlg) dlg.addEventListener('pointerup', function(e){
      if (!(e.target.closest && e.target.closest('.product-media-modal__toggle'))) e.stopPropagation();
    });
    /* Ordinateur : clic sur l'image = zoom x2 qui suit la souris ; 2e clic = dezoom ; clic a cote de l'image = fermer */
    content.addEventListener('click', function(e){
      if (window.matchMedia('(hover: none)').matches) return;
      var el = e.target;
      if (el.closest && el.closest('deferred-media, product-model, video, button, a')) return;
      if (el.tagName === 'IMG' && el.parentNode === content && insideImg(el, e.clientX, e.clientY)) { if (deskScale(el) > 1) deskZoom(modal, content, el, e.clientX, e.clientY); return; }
      if (modal.hide) modal.hide();
    });
    content.addEventListener('mousemove', function(e){
      if (window.matchMedia('(hover: none)').matches) return;
      var el = e.target;
      content.classList.toggle('mpn-zin', el.tagName === 'IMG' && el.parentNode === content && insideImg(el, e.clientX, e.clientY) && deskScale(el) > 1);
    });
    content.addEventListener('mouseleave', function(){ content.classList.remove('mpn-zin'); });
    var list = items(content);
    if (list.length > 1) {
      list.forEach(function(el, k){
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'mpn-modal-thumb'; b.setAttribute('aria-label', MPN_T.img + ' ' + (k + 1));
        var src = thumbSrc(el);
        if (src) { var t = document.createElement('img'); t.src = src; t.alt = ''; t.loading = 'lazy'; b.appendChild(t); }
        b.addEventListener('click', function(){ resetZoom(modal, false); goTo(content, k, true); });
        thumbs.appendChild(b);
      });
    }
    if (list.length > 1) {
      [-1, 1].forEach(function(dir){
        var a = document.createElement('button');
        a.type = 'button'; a.className = 'mpn-modal-arr mpn-modal-arr--' + (dir < 0 ? 'prev' : 'next');
        a.setAttribute('aria-label', dir < 0 ? MPN_T.prev : MPN_T.next);
        a.innerHTML = '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="' + (dir < 0 ? 'M10 3 5 8l5 5' : 'm6 3 5 5-5 5') + '" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
        a.addEventListener('click', function(){ step(modal, dir); });
        content.parentNode.appendChild(a);
      });
      document.addEventListener('keydown', function(e){
        if (!modal.hasAttribute('open')) return;
        if (e.target && /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); step(modal, 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); step(modal, -1); }
      });
    }
    var raf = 0;
    content.addEventListener('scroll', function(){ if (raf) return; raf = requestAnimationFrame(function(){ raf = 0; mark(modal); }); }, { passive: true });

    var g = null;
    var lastTap = 0, tapX = 0, tapY = 0;
    content.addEventListener('touchstart', function(e){
      var z = zoomState(modal);
      if (e.touches.length === 2) {
        var img = z.el || currentImg(content);
        if (!img) return;
        e.preventDefault();
        z.el = img;
        var c = centerOf(img), m = mid(e.touches[0], e.touches[1]);
        if (z.s === 1) { var r = img.getBoundingClientRect(); c = { x: r.left + r.width / 2, y: r.top + r.height / 2 }; }
        g = { type: 'pinch', d0: dist(e.touches[0], e.touches[1]), s0: z.s, c: { x: c.x - z.tx, y: c.y - z.ty } };
        g.qx = (m.x - g.c.x - z.tx) / z.s; g.qy = (m.y - g.c.y - z.ty) / z.s;
        content.classList.add('is-zoomed');
        return;
      }
      if (e.touches.length === 1) {
        var t = e.touches[0];
        if (z.s > 1) { e.preventDefault(); g = { type: 'pan', x0: t.clientX, y0: t.clientY, tx0: z.tx, ty0: z.ty, moved: false }; }
        else { g = { type: 'swipe', x0: t.clientX, y0: t.clientY, i0: idxOf(content), moved: false }; }
      }
    }, { passive: false });

    content.addEventListener('touchmove', function(e){
      if (!g) return;
      var z = zoomState(modal);
      if (g.type === 'pinch' && e.touches.length === 2) {
        e.preventDefault();
        var s = Math.max(1, Math.min(MAX, g.s0 * dist(e.touches[0], e.touches[1]) / g.d0));
        var m = mid(e.touches[0], e.touches[1]);
        z.s = s;
        z.tx = m.x - g.c.x - g.qx * s;
        z.ty = m.y - g.c.y - g.qy * s;
        clampT(z); apply(z, false);
      } else if (g.type === 'pan' && e.touches.length === 1) {
        e.preventDefault();
        var t = e.touches[0];
        z.tx = g.tx0 + (t.clientX - g.x0); z.ty = g.ty0 + (t.clientY - g.y0);
        if (Math.abs(t.clientX - g.x0) + Math.abs(t.clientY - g.y0) > 6) g.moved = true;
        clampT(z); apply(z, false);
      } else if (g.type === 'swipe') {
        var tt = e.touches[0];
        if (Math.abs(tt.clientX - g.x0) + Math.abs(tt.clientY - g.y0) > 6) g.moved = true;
      }
    }, { passive: false });

    content.addEventListener('touchend', function(e){
      if (!g) return;
      var z = zoomState(modal);
      var cur = g;
      if (cur.type === 'pinch') {
        if (e.touches.length === 1) { var t1 = e.touches[0]; g = { type: 'pan', x0: t1.clientX, y0: t1.clientY, tx0: z.tx, ty0: z.ty, moved: true }; }
        else g = null;
        if (z.s < 1.05) resetZoom(modal, true);
        return;
      }
      g = null;
      var t = e.changedTouches[0]; if (!t) return;
      if (!cur.moved) {
        var now = Date.now();
        if (now - lastTap < 300 && Math.abs(t.clientX - tapX) < 30 && Math.abs(t.clientY - tapY) < 30) {
          lastTap = 0;
          if (z.s > 1) { resetZoom(modal, true); }
          else {
            var img = currentImg(content); if (!img) return;
            z.el = img; var c = centerOf(img); var s = 2.5;
            z.s = s; z.tx = (c.x - t.clientX) * (s - 1); z.ty = (c.y - t.clientY) * (s - 1);
            clampT(z); apply(z, true); content.classList.add('is-zoomed');
          }
          return;
        }
        lastTap = now; tapX = t.clientX; tapY = t.clientY;
        return;
      }
      if (cur.type === 'swipe') {
        var dx = t.clientX - cur.x0, dy = t.clientY - cur.y0, n = items(content).length;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        if (dx < 0 && cur.i0 === n - 1) goTo(content, 0, true);
        else if (dx > 0 && cur.i0 === 0) goTo(content, n - 1, true);
      }
    }, { passive: true });

    modal.addEventListener('gesturestart', function(e){ e.preventDefault(); });
    modal.addEventListener('gesturechange', function(e){ e.preventDefault(); });
  }

  /* Zone reellement occupee par la photo (affichee en entier, centree) dans sa boite */
  function insideImg(img, x, y){
    var r = img.getBoundingClientRect(), cs = getComputedStyle(img);
    var pl = parseFloat(cs.paddingLeft) || 0, pr = parseFloat(cs.paddingRight) || 0, pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
    var bw = r.width - pl - pr, bh = r.height - pt - pb;
    var nw = img.naturalWidth || bw, nh = img.naturalHeight || bh;
    var s = Math.min(bw / nw, bh / nh), w = nw * s, h = nh * s;
    var l = r.left + pl + (bw - w) / 2, t = r.top + pt + (bh - h) / 2;
    return x >= l && x <= l + w && y >= t && y <= t + h;
  }
  /* Zoom ordinateur : un calque affiche la photo d'origine (la plus grande disponible) agrandie, et se deplace avec la souris
     (souris a gauche = bord gauche de la photo, etc.). Grossissement limite a ce que la photo permet en restant nette. */
  var DZ = 1.6;
  function geo(img){
    var r = img.getBoundingClientRect(), cs = getComputedStyle(img);
    var pl = parseFloat(cs.paddingLeft) || 0, pr = parseFloat(cs.paddingRight) || 0, pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
    var bw = r.width - pl - pr, bh = r.height - pt - pb;
    var nw = img.naturalWidth || bw, nh = img.naturalHeight || bh, k = Math.min(bw / nw, bh / nh);
    return { r: r, iw: nw * k, ih: nh * k };
  }
  function origOf(img){
    var best = null;
    (img.getAttribute('srcset') || '').split(',').forEach(function(p){
      var q = p.trim().split(/\s+/); if (!q[0]) return;
      var w = parseInt(q[1], 10) || 0;
      if (!best || w > best.w) best = { u: q[0], w: w };
    });
    return best && best.w ? best : { u: img.currentSrc || img.src, w: img.naturalWidth || 0 };
  }
  /* Grossissement possible pour cette photo (1 = pas de zoom : la photo d'origine est trop petite pour etre plus nette) */
  function deskScale(img){
    var g = geo(img), o = origOf(img), dpr = Math.min(2, window.devicePixelRatio || 1);
    if (!g.iw || !o.w) return 1;
    var s = Math.min(DZ, (o.w * 1.15) / (g.iw * dpr));
    return s >= 1.2 ? s : 1;
  }
  /* Deplacement fluide : la photo agrandie est un calque deplace par la carte graphique (translate3d, sans redessiner l'image),
     colle a la souris sans aucun retard (une mise a jour par image affichee par l'ecran, pas d'amorti : demande d'Ed). */
  function deskZoom(modal, content, img, x, y){
    var dlg = modal.querySelector('.product-media-modal__dialog'); if (!dlg) return;
    var zl = modal.__mpnZl;
    if (!zl) {
      zl = modal.__mpnZl = document.createElement('div'); zl.className = 'mpn-zl'; zl.setAttribute('aria-hidden', 'true');
      zl.innerHTML = '<div class="mpn-zl__in"><img class="mpn-zl__hi" alt="" decoding="async" draggable="false"></div>';
      dlg.appendChild(zl);
      var off = function(){ zl.classList.remove('is-on'); content.classList.remove('is-zoomed'); if (zl.__raf) { cancelAnimationFrame(zl.__raf); zl.__raf = 0; } };
      zl.addEventListener('mousemove', function(e){ if (zl.__b) deskFollow(zl, e.clientX, e.clientY); });
      zl.addEventListener('click', function(e){ e.stopPropagation(); off(); });
      zl.addEventListener('wheel', off, { passive: true });
    }
    var inn = zl.firstChild, hi = inn.firstChild;
    var g = geo(img), s = deskScale(img), o = origOf(img), dr = dlg.getBoundingClientRect();
    var cr = content.getBoundingClientRect();
    /* le calque couvre toute la zone photo (sous le bouton Fermer, au-dessus des miniatures) */
    zl.style.left = (cr.left - dr.left) + 'px'; zl.style.top = (cr.top - dr.top) + 'px';
    zl.style.width = cr.width + 'px'; zl.style.height = cr.height + 'px';
    var W = Math.round(g.iw * s), H = Math.round(g.ih * s);
    zl.__b = { l: cr.left, t: cr.top, w: cr.width, h: cr.height, iw: W, ih: H };
    inn.style.width = W + 'px'; inn.style.height = H + 'px';
    var cur = img.currentSrc || img.src;
    inn.style.backgroundImage = cur ? 'url("' + cur + '")' : 'none';
    if (hi.getAttribute('src') !== o.u) {
      hi.style.opacity = '0';
      hi.onload = function(){ hi.style.opacity = '1'; };
      hi.setAttribute('src', o.u);
      if (hi.complete && hi.naturalWidth) hi.style.opacity = '1';
    }
    content.classList.remove('mpn-zin'); content.classList.add('is-zoomed');
    zl.classList.add('is-on');
    zl.__c = null;
    deskFollow(zl, x, y);
  }
  function deskFollow(zl, x, y){
    var b = zl.__b;
    var fx = Math.max(0, Math.min(1, (x - b.l) / (b.w || 1))), fy = Math.max(0, Math.min(1, (y - b.t) / (b.h || 1)));
    var px = b.iw > b.w ? -(b.iw - b.w) * fx : (b.w - b.iw) / 2;
    var py = b.ih > b.h ? -(b.ih - b.h) * fy : (b.h - b.ih) / 2;
    var first = !zl.__c;
    zl.__c = { x: px, y: py };
    if (first) { paintZl(zl); return; }
    if (!zl.__raf) zl.__raf = requestAnimationFrame(function(){ zl.__raf = 0; paintZl(zl); });
  }
  function paintZl(zl){ zl.firstChild.style.transform = 'translate3d(' + zl.__c.x.toFixed(1) + 'px,' + zl.__c.y.toFixed(1) + 'px,0)'; }
  function step(modal, dir){
    var content = modal.querySelector('.product-media-modal__content');
    if (!content) return;
    var n = items(content).length, k = idxOf(content) + dir;
    if (k < 0) k = n - 1; if (k >= n) k = 0;
    resetZoom(modal, false); goTo(content, k, true);
  }
  function onOpen(modal){
    if (!mq.matches) return;
    build(modal);
    resetZoom(modal, false);
    var content = modal.querySelector('.product-media-modal__content');
    var thumbs = modal.querySelector('.mpn-modal-thumbs');
    if (!content) return;
    if (thumbs) thumbs.scrollLeft = 0;
    requestAnimationFrame(function(){
      var list = items(content), idx = 0;
      list.forEach(function(el, k){ if (el.classList.contains('active')) idx = k; });
      goTo(content, idx, false);
      modal.__mpnIdx = -1;
      requestAnimationFrame(function(){ mark(modal, false); });
    });
  }
  function init(){
    document.querySelectorAll('product-modal').forEach(function(modal){
      if (modal.__mpnObs) return; modal.__mpnObs = true;
      new MutationObserver(function(){ if (modal.hasAttribute('open')) onOpen(modal); else { resetZoom(modal, false); modal.querySelectorAll('video').forEach(function(v){ if (v.pause) v.pause(); }); } }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
